import { DataNotFound } from '../../../CommonComponents/DataNotFound';


const ITBasic = () => {

    return (
        <DataNotFound />
    );
};

export default ITBasic;
